var render = function render(_c,_vm){return _c('div',_vm._b({class:['TkTextBox', { '-disabled': _vm.props.disabled }, _vm.data.staticClass],style:([
    _vm.$options.styleVars(_vm.props),
    _vm.props.width ? { width: `${_vm.props.width}px` } : {},
  ])},'div',(() => {
    // 親のスコープIDを設定しルート要素だけ親の scoped css を反映できるようにする
    _vm.data.attrs[_vm.parent.$options._scopeId] = ''
    return _vm.data.attrs
  })(),false),[_c('input',_vm._g({class:[
      'tkTextBox_input',
      `-${_vm.props.theme}`,
      { [`-${_vm.props.color}`]: !!_vm.props.color },
      { '-putIconOutside': _vm.props.putIconOutside },
      { '-noBorder': _vm.props.noBorder },
      { '-bold': _vm.props.bold },
      { '-active': _vm.props.active },
    ],attrs:{"type":"text","placeholder":_vm.props.placeholder,"disabled":_vm.props.disabled,"readonly":_vm.props.readonly},domProps:{"value":_vm.props.value}},{
      ..._vm.listeners,
      // 基本的にはイベントハンドラーは全て <input> タグに流すが、@input イベントだけは v-model の仕様に合わせる
      ...(_vm.listeners.input ? { input: $event => _vm.listeners.input($event.target.value) } : {}),
    })),(_vm.props.icon)?_c(_vm.$options.components.TkIcon,{tag:"component",class:[
      ' tkTextBox_icon',
      { '-putIconOutside': _vm.props.putIconOutside },
    ],attrs:{"name":_vm.props.icon,"color":_vm.props.iconColor}}):_vm._e(),(_vm.props.iconSeparator)?_c('div',{class:[
      'tkTextBox_separator',
      `-${_vm.props.iconSeparator}`,
    ]}):_vm._e(),(_vm.props.autocompleteItems.length > 0)?_c('ul',{class:[
      'tkTextBox_autocomplete',
      `-${_vm.props.theme}`,
      `-${_vm.props.size}`,
      { '-putIconOutside': _vm.props.putIconOutside },
    ],style:({
      'max-height': `${_vm.props.maxAutocompleteBoxHeight}px`,
    })},_vm._l((_vm.props.autocompleteItems),function(item,index){return _c('li',{key:item.value,class:[
        'tkTextBox_autocompleteItem',
        `-${_vm.props.theme}`,
        `-${_vm.props.size}`,
        index < _vm.props.autocompleteItems.length - 1 ? '-border' : null,
      ],on:{"click":function($event){_vm.listeners.autocomplete ? _vm.listeners.autocomplete(item.value) : null}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }